export const level14 = [
  {
    level: "P1",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "boyChild2Img",
        imageTwo: "thingirlImg",
      },
      conversation: [
        {
          speaker: "What is your favourite season?",
          user: "I like the rainy season.",
          audio: "level14P1OneUAudio",
          speakerAudio: "level14P1OneSAudio",
        },
        {
          speaker: "Why do you like this season?",
          user: "Rainy season is fresh and pleasant.",
          audio: "level14P1TwoUAudio",
          speakerAudio: "level14P1TwoSAudio",
        },
        {
          speaker: "How is this season different from summer?",
          user: "Rainy season is cool and wet, but summer is hot and dry.",
          audio: "level14P1ThreeUAudio",
          speakerAudio: "level14P1ThreeSAudio",
        },
        {
          speaker: "What do people use in this season?",
          user: "People use umbrellas and wear raincoats in the rain.",
          audio: "level14P1FourUAudio",
          speakerAudio: "level14P1FourSAudio",
        },
        {
          speaker: "What do you eat in this season?",
          user: "I like eating hot snacks like bajjis and drinking tea.",
          audio: "level14P1FiveUAudio",
          speakerAudio: "level14P1FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P2",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "collegeGirlImg",
        imageTwo: "boyChild2Img",
      },
      conversation: [
        {
          speaker: "What is your favourite pet animal?",
          user: "Cat",
          audio: "level14P2OneUAudio",
          speakerAudio: "level14P2OneSAudio",
        },
        {
          speaker: "Why do you like this animal?",
          user: "Because the cat is naughty and playful.",
          audio: "level14P2TwoUAudio",
          speakerAudio: "level14P2TwoSAudio",
        },
        {
          speaker: "Where does this animal live?",
          user: "Cats live in homes and sometimes on the streets.",
          audio: "level14P2ThreeUAudio",
          speakerAudio: "level14P2ThreeSAudio",
        },
        {
          speaker: "How does this animal help people?",
          user: "It keeps the house free from rats.",
          audio: "level14P2FourUAudio",
          speakerAudio: "level14P2FourSAudio",
        },
        {
          speaker: "Why do people like this animal?",
          user: "Because it is gentle and easy to care for.",
          audio: "level14P2FiveUAudio",
          speakerAudio: "level14P2FiveSAudio",
        },
        // {
        //   speaker: "Why do people like this animal?",
        //   user: "Because it is loving and protective.",
        //   audio: "level14P2SixUAudio",
        // },
      ],
    },
  },
  {
    level: "P3",
    mechanics: "actOut",
    data: {
      images: {
        imageOne: "thingirlImg",
        imageTwo: "femaleAstronautImg",
      },
      conversation: [
        {
          speaker: "What is your profession?",
          user: "I am an astronaut.",
          audio: "level14P3OneUAudio",
          speakerAudio: "level14P3OneSAudio",
        },
        {
          speaker: "What do you do as an astronaut?",
          user: "I travel to space in spaceships and do experiments.",
          audio: "level14P3TwoUAudio",
          speakerAudio: "level14P3TwoSAudio",
        },
        {
          speaker: "What do you see in space?",
          user: "I see Earth, stars, and planets from my spaceship.",
          audio: "level14P3ThreeUAudio",
          speakerAudio: "level14P3ThreeSAudio",
        },
        {
          speaker: "Do you feel scared up there?",
          user: "A little, but it’s also exciting and fun.",
          audio: "level14P3FourUAudio",
          speakerAudio: "level14P3FourSAudio",
        },
        {
          speaker: "Why is your work important?",
          user: "My research and experiments help people learn more about space.",
          audio: "level14P3FiveUAudio",
          speakerAudio: "level14P3FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P4",
    mechanics: "actOut",
    data: {
      images: {
        imageOne: "cricketBoyImg",
        imageTwo: "hockeyGirlImg",
      },
      conversation: [
        {
          speaker: "How are cricket and hockey different?",
          user: "Cricket is played with a bat and ball, but hockey is played with a stick and ball.",
          audio: "level14P4OneUAudio",
          speakerAudio: "level14P4OneSAudio",
        },
        {
          speaker: "Which sport do you like more and why?",
          user: "I like hockey more because it is fast and fun to watch.",
          audio: "level14P4TwoUAudio",
          speakerAudio: "level14P4TwoSAudio",
        },
        {
          speaker: "Where do we play cricket and hockey?",
          user: "Cricket is played on a big field, and hockey is played on a flat ground or turf.",
          audio: "level14P4ThreeUAudio",
          speakerAudio: "level14P4ThreeSAudio",
        },
        {
          speaker: "What equipment do players use in cricket and hockey?",
          user: "Cricket players use bats, balls, and pads̤ Hockey players use sticks, balls, and safety gear.",
          audio: "level14P4FourUAudio",
          speakerAudio: "level14P4FourSAudio",
        },
        {
          speaker: "Why do people enjoy cricket and hockey?",
          user: "People enjoy cricket because  it is strategic and thrilling, People love hockey for its speed and action.",
          audio: "level14P4FiveUAudio",
          speakerAudio: "level14P4FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P5",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "boyChild2Img",
        imageTwo: "girlSprinterImg",
      },
      conversation: [
        {
          speaker: "What is your favourite sport?",
          user: "My favourite sport is Kabaddi.",
          audio: "level14P5OneUAudio",
          speakerAudio: "level14P5OneSAudio",
        },
        {
          speaker: "Why do you like this sport?",
          user: " I like Kabaddi because it is fast and exciting.",
          audio: "level14P5TwoUAudio",
          speakerAudio: "level14P5TwoSAudio",
        },
        {
          speaker: "Where do you play this sport?",
          user: "I play Kabaddi on a small court or open ground.",
          audio: "level14P5ThreeUAudio",
          speakerAudio: "level14P5ThreeSAudio",
        },
        {
          speaker: "How is this sport different from others?",
          user: "Kabaddi is a physical game where players tag and escape.",
          audio: "level14P5FourUAudio",
          speakerAudio: "level14P5FourSAudio",
        },
        {
          speaker: "What do players wear while playing?",
          user: "Kabaddi players wear T-shirts, shorts, and sports shoes",
          audio: "level14P5FiveUAudio",
          speakerAudio: "level14P5FiveSAudio",
        },
        // {
        //   speaker: "Why do people like this sport?",
        //   user: "People like cricket because it is thrilling and famous.",
        //   audio: "level14P5SixUAudio",
        // },
      ],
    },
  },
  {
    level: "P6",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "thingirlImg",
        imageTwo: "deliverymanImg",
      },
      conversation: [
        {
          speaker: "What is your favourite transport?",
          user: "My favourite mode of transport is a bike.",
          audio: "level14P6OneUAudio",
          speakerAudio: "level14P6OneSAudio",
        },
        {
          speaker: "Why do you like this transport?",
          user: "I like bikes because they are fast and fun to ride.",
          audio: "level14P6TwoUAudio",
          speakerAudio: "level14P6TwoSAudio",
        },
        {
          speaker: "Where do you use this transport?",
          user: "I use a bike to go to nearby places.",
          audio: "level14P6ThreeUAudio",
          speakerAudio: "level14P6FourSAudio",
        },
        {
          speaker: "How is this transport different from others?",
          user: "A bike is smaller and quicker than a car or bus.",
          audio: "level14P6FourUAudio",
          speakerAudio: "level14P6FiveSAudio",
        },
        {
          speaker: "What do people carry while travelling?",
          user: "People carry a helmet, a bag, and sometimes food items.",
          audio: "level14P6FiveUAudio",
        },
        // {
        //   speaker: "Why do people like this transport?",
        //   user: "People like bicycles because they are healthy.",
        //   audio: "level14P6FiveUAudio",
        // },
      ],
    },
  },
  {
    level: "P7",
    mechanics: "actOut",
    data: {
      images: {
        imageOne: "boyChild2Img",
        imageTwo: "femaleTrekkerImg",
      },
      conversation: [
        {
          speaker: "Where are you going?",
          user: "I am going on a trek in the hills.",
          audio: "level14P7OneUAudio",
          speakerAudio: "level14P7OneSAudio",
        },
        {
          speaker: "What are you carrying for the trek?",
          user: "I have a backpack with water, snacks, and a jacket.",
          audio: "level14P7TwoUAudio",
          speakerAudio: "level14P7TwoSAudio",
        },
        {
          speaker: "Is someone going with you?",
          user: "Yes, two of my friends are coming with me.",
          audio: "level14P7ThreeUAudio",
          speakerAudio: "level14P7ThreeSAudio",
        },
        {
          speaker: "How often do you go for a trek?",
          user: "I go trekking once a month, usually on weekends.",
          audio: "level14P7FourUAudio",
          speakerAudio: "level14P7FourSAudio",
        },
        {
          speaker: "Why do you like trekking?",
          user: "I like trekking because it is adventurous and refreshing.",
          audio: "level14P7FiveUAudio",
          speakerAudio: "level14P7FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P8",
    mechanics: "actOut",
    data: {
      images: {
        imageOne: "thingirlImg",
        imageTwo: "ladyImg",
      },
      conversation: [
        {
          speaker: "How are cows and sheep different?",
          user: "Cows are bigger and give more milk, while sheep are smaller and have wool.",
          audio: "level14P8OneUAudio",
          speakerAudio: "level14P8OneSAudio",
        },
        {
          speaker: "Which animal do you like more and why?",
          user: "I like cows more because they are gentle and useful.",
          audio: "level14P8TwoUAudio",
          speakerAudio: "level14P8TwoSAudio",
        },
        {
          speaker: "How do we take care of cows and sheep?",
          user: "We feed them grass, keep them clean, and give them shelter.",
          audio: "level14P8ThreeUAudio",
          speakerAudio: "level14P8ThreeSAudio",
        },
        {
          speaker: "What do cows and sheep eat?",
          user: "They both eat grass, but cows also eat grains and hay.",
          audio: "level14P8FourUAudio",
          speakerAudio: "level14P8FourSAudio",
        },
        {
          speaker: "Why do people keep cows and sheep?",
          user: "People keep cows for milk and sheep for wool.",
          audio: "level14P8FiveUAudio",
          speakerAudio: "level14P8FiveSAudio",
        },
      ],
    },
  },
  {
    level: "S1",
    mechanics: "actOut",
    data: {
      images: {
        imageOne: "boyChild2Img",
        imageTwo: "thingirlImg",
      },
      conversation: [
        {
          speaker: "Which is your favourite season?",
          user: "I like the rainy season.",
          audio: "level14S1OneUAudio",
          speakerAudio: "level14S1OneSAudio",
        },
        {
          speaker: "Why do you like this season?",
          user: "I like to play in water.",
          audio: "level14S1TwoUAudio",
          speakerAudio: "level14S1TwoSAudio",
        },
        {
          speaker: " When does this season occur?",
          user: "From july to October.",
          audio: "level14S1ThreeUAudio",
          speakerAudio: "level14S1ThreeSAudio",
        },
        {
          speaker: "What do people use during raining?",
          user: "People use umbrellas and raincoats.",
          audio: "level14S1FourUAudio",
          speakerAudio: "level14S1FourSAudio",
        },
        {
          speaker: "What do you eat this season?",
          user: "I like eating pakoras or bajjis.",
          audio: "level14S1FiveUAudio",
          speakerAudio: "level14S1FiveSAudio",
        },
      ],
    },
  },
  {
    level: "S2",
    mechanics: "actOut",
    data: {
      images: {
        imageOne: "boyChild2Img",
        imageTwo: "thingirlImg",
      },
      conversation: [
        {
          speaker: "What is your favourite transport?",
          user: "My favourite transport is a bus.",
          audio: "level14S2OneUAudio",
          speakerAudio: "level14S2OneSAudio",
        },
        {
          speaker: "Where do you use this transport?",
          user: "Buses are comfortable and affordable.",
          audio: "level14S2TwoUAudio",
          speakerAudio: "level14S2TwoSAudio",
        },
        {
          speaker: "Where do you use this transport?",
          user: "To go to school",
          audio: "level14S2ThreeUAudio",
          speakerAudio: "level14S2ThreeSAudio",
        },
        {
          speaker: "How often do you use a bus?",
          user: "I use a bus daily.",
          audio: "level14S2FourUAudio",
          speakerAudio: "level14S2FourSAudio",
        },
        {
          speaker: "What do you carry while going to school?",
          user: "I carry my school bag, lunch box and a water bottle.",
          audio: "level14S2FiveUAudio",
          speakerAudio: "level14S2FiveSAudio",
        },
      ],
    },
  },
];

export const level13 = [
  {
    level: "P1",
    mechanics: "ReadAloudMcqM10",
    data: {
      instructions: {
        type: "chat",
        completeAudio: "level13P1CAudio",
        content: [
          {
            role: "System",
            name: "Gopal",
            message: "Hello, doctor. I have a stomachache today.",
            audio: "level13P1Audio1",
          },
          {
            role: "User",
            name: "Doctor",
            message: "Since when have you felt this pain, Gopal?",
            audio: "level13P1Audio2",
          },
          {
            role: "System",
            name: "Gopal",
            message: "It started last night after I ate dinner.",
            audio: "level13P1Audio3",
          },
          {
            role: "User",
            name: "Doctor",
            message: "What did you eat yesterday evening?",
            audio: "level13P1Audio4",
          },
          {
            role: "System",
            name: "Gopal",
            message: "I ate some snacks from a roadside stall.",
            audio: "level13P1Audio5",
          },
          {
            role: "User",
            name: "Doctor",
            message:
              "That might be the cause of your pain. You must avoid such food.",
            audio: "level13P1Audio6",
          },
          {
            role: "System",
            name: "Gopal",
            message: "What should I do now, doctor?",
            audio: "level13P1Audio7",
          },
          {
            role: "User",
            name: "Doctor",
            message:
              "I will prescribe you mild medicines. Take this tablet for three days, twice a day.",
            audio: "level13P1Audio8",
          },
          {
            role: "System",
            name: "Gopal",
            message: "Should I eat anything special now?",
            audio: "level13P1Audio9",
          },
          {
            role: "User",
            name: "Doctor",
            message: "Eat soft food and drink warm water.",
            audio: "level13P1Audio10",
          },
          {
            role: "System",
            name: "Gopal",
            message: "Okay. Thank you, doctor. I will be careful.",
            audio: "level13P1Audio11",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Who are the speakers in the conversation?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Teacher and student",
            },
            {
              type: "text",
              id: "option2",
              value: "Doctor and patient",
            },
            {
              type: "text",
              id: "option3",
              value: "Shopkeeper and customer",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Why did Gopal visit the doctor?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "He had a cold",
            },
            {
              type: "text",
              id: "option2",
              value: "He had a stomachache",
            },
            {
              type: "text",
              id: "option3",
              value: "He had a headache",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What did Gopal eat the night before?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Homemade food",
            },
            {
              type: "text",
              id: "option2",
              value: "Snacks from a stall",
            },
            {
              type: "text",
              id: "option3",
              value: "Fruits and milk",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What advice did the doctor give Gopal?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Take rest all day",
            },
            {
              type: "text",
              id: "option2",
              value: "Eat sweets",
            },
            {
              type: "text",
              id: "option3",
              value: "Avoid roadside food",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What type of food should Gopal eat now?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Soft food",
            },
            {
              type: "text",
              id: "option2",
              value: "Fried food",
            },
            {
              type: "text",
              id: "option3",
              value: "Spicy food",
            },
          ],
          answer: "option1",
        },
      ],
    },
  },
  {
    level: "P2",
    mechanics: "whatsMissing",
    data: {
      data: [
        {
          question:
            "Hey, have you decided where to go for your summer ________?",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "meetingImg", text: "Meeting" },
            { img: "vacationImg", text: "Vacation" },
            { img: "partyImg", text: "Party" },
          ],
          correctAnswer: "Vacation",
          hints: "People go for this to relax.",
        },
        {
          question:
            "I’m thinking about going to a ________, but I haven’t decided yet.",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "hillstationImg", text: "Hill station" },
            { img: "mall3Img", text: "Mall" },
            { img: "restaurant2Img", text: "Restaurant" },
          ],
          correctAnswer: "Hill station",
          hints: " It has greenery around.",
        },
        {
          question: "Maybe for ________ days. I don’t have a lot of time off.",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "threeImg", text: "Three" },
            { img: "tenImg", text: "Ten" },
            { img: "fiveImg", text: "Five" },
          ],
          correctAnswer: "Five",
          hints: "It is more than three but less than ten.",
        },
        {
          question: "Are you travelling ________ or with someone?",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "alone2Img", text: "Alone" },
            { img: "family2Img", text: "In a group" },
            { img: "freind2Img", text: "With family" },
          ],
          correctAnswer: "Alone",
          hints: "The person enjoys being by themselves.",
        },
        {
          question:
            "I love watching the __________ at the hill station and enjoy being alone.",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "sunriseImg", text: "sunrise" },
            { img: "peopleImg", text: "people" },
            { img: "villageImg", text: "village" },
          ],
          correctAnswer: "sunrise",
          hints:
            "It happens early in the morning and looks beautiful in the hills.",
        },
      ],
    },
  },
  {
    level: "P3",
    mechanics: "arrangePicture",
    data: {
      images: [
        { img: "henOneImg", id: "1" },
        { img: "henFourImg", id: "4" },
        { img: "henThreeImg", id: "3" },
        { img: "henFiveImg", id: "5" },
        { img: "henTwoImg", id: "2" },
      ],
      audioData: [
        {
          audio: "henOneAudio",
          text: "A hen lives happily on a farm with her four little chicks.",
        },
        {
          audio: "henTwoAudio",
          text: "Every morning, she takes them out to search for food. They peck at the ground and eat whatever they find.",
        },
        {
          audio: "henThreeAudio",
          text: "A dog watches them from behind the fence. He is waiting for a chance to catch a chick.",
        },
        {
          audio: "henFourAudio",
          text: "He waits until evening, but the chicks stay close to their mother. He cannot catch even a single one.",
        },
      ],
    },
  },
  {
    level: "P4",
    mechanics: "fillInTheBlankNew",
    data: {
      instruction: {
        content: [
          {
            type: "image",
            value: "healthyHabits2Img",
          },
        ],
      },
      tasks: [
        {
          question: "Eat fruits and vegetables ______.",
          options: [
            { id: "option1", value: "Provides vitamins and minerals" },
            { id: "option2", value: "Keeps you hydrated" },
            { id: "option3", value: "Boosts energy and concentration" },
          ],
          answer: "option1",
        },
        {
          question: "Drink plenty of water ______.",
          options: [
            { id: "option1", value: "Keeps you hydrated" },
            { id: "option2", value: "Reduces the risk of obesity" },
            { id: "option3", value: "Helps maintain a healthy weight" },
          ],
          answer: "option1",
        },
        {
          question: "Never skip morning breakfast ______.",
          options: [
            { id: "option1", value: "Boosts energy and concentration" },
            { id: "option2", value: "Improves memory" },
            { id: "option3", value: "Increases sugar levels" },
          ],
          answer: "option1",
        },
        {
          question: "Say ‘NO’ to junk food ______.",
          options: [
            { id: "option1", value: "Reduces the risk of obesity" },
            { id: "option2", value: "Provides vitamins and minerals" },
            { id: "option3", value: "Increases sugar levels" },
          ],
          answer: "option1",
        },
        {
          question: "Eat whole grains and millets ______.",
          options: [
            { id: "option1", value: "Helps maintain a healthy and fit body" },
            { id: "option2", value: "Builds strong teeth" },
            { id: "option3", value: "Cures cold and cough" },
          ],
          answer: "option1",
        },
      ],
    },
  },
  {
    level: "S1",
    mechanics: "ReadAloudMcqM10",
    data: {
      instructions: {
        type: "chat",
        completeAudio: "level13S1CAudio",
        content: [
          {
            role: "System",
            name: "Ramesh",
            message: "Hi Megha! Are you joining the sports competition?",
            audio: "level13S1Audio1",
          },
          {
            role: "User",
            name: "Megha",
            message: "Yes! I’m excited. Are you playing too?",
            audio: "level13S1Audio2",
          },
          {
            role: "System",
            name: "Ramesh",
            message:
              "Yes, I’m running in the 100-meter race. I practice running early in the morning.",
            audio: "level13S1Audio3",
          },
          {
            role: "User",
            name: "Megha",
            message:
              "That’s great! I’m playing in the throwball game. I practice with my sister every evening.Do you feel nervous before the race?",
            audio: "level13S1Audio4",
          },
          {
            role: "System",
            name: "Ramesh",
            message: "A little, but I enjoy running fast.",
            audio: "level13S1Audio5",
          },
          {
            role: "User",
            name: "Megha",
            message: "That’s the spirit! Winning isn’t everything.",
            audio: "level13S1Audio6",
          },
          {
            role: "System",
            name: "Ramesh",
            message: "Right! Taking part is also important.",
            audio: "level13S1Audio7",
          },
          {
            role: "User",
            name: "Megha",
            message: "See you, bye!",
            audio: "level13S1Audio8",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What did Ramesh ask Megha at the beginning?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "To join the sports competition",
            },
            {
              type: "text",
              id: "option2",
              value: "To play in the throwball game",
            },
            {
              type: "text",
              id: "option3",
              value: "To run in the 100-meter race",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "When did Megha practice for the throwball game?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Every evening",
            },
            {
              type: "text",
              id: "option2",
              value: "After dinner",
            },
            {
              type: "text",
              id: "option3",
              value: "After breakfast",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "When did Ramesh practice for the 100-meter race?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Every evening",
            },
            {
              type: "text",
              id: "option2",
              value: "Every morning",
            },
            {
              type: "text",
              id: "option3",
              value: "Every night",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What did Megha ask Ramesh at the end?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Let’s meet at the park",
            },
            {
              type: "text",
              id: "option2",
              value: "Do you feel nervous before the race?",
            },
            {
              type: "text",
              id: "option3",
              value: "To play in the throwball game",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value:
              "How did Megha feel after participating in the sports competition?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Nervous",
            },
            {
              type: "text",
              id: "option2",
              value: "Happy",
            },
            {
              type: "text",
              id: "option3",
              value: "Sad",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
  {
    level: "P5",
    mechanics: "ReadAloudMcqM10",
    data: {
      instructions: {
        type: "chat",
        completeAudio: "level13P5CAudio",
        content: [
          {
            role: "System",
            name: "Girish",
            message: "Hi Mary! Did you read any storybooks recently?",
            audio: "level13P5Audio1",
          },
          {
            role: "User",
            name: "Mary",
            message: "Yes! I read The Clever Fox.",
            audio: "level13P5Audio2",
          },
          {
            role: "System",
            name: "Girish",
            message: "Sounds fun! Was it an animal story?",
            audio: "level13P5Audio3",
          },
          {
            role: "User",
            name: "Mary",
            message: "Yes, the fox tricks the lion in the end.",
            audio: "level13P5Audio4",
          },
          {
            role: "System",
            name: "Girish",
            message:
              "Nice! I read Tenali Raman’s Trick. I love Tenali stories! So funny!",
            audio: "level13P5Audio5",
          },
          {
            role: "User",
            name: "Mary",
            message: "Do you read every day?",
            audio: "level13P5Audio6",
          },
          {
            role: "System",
            name: "Girish",
            message: "Yes, I read before going to bed. You?",
            audio: "level13P5Audio7",
          },
          {
            role: "User",
            name: "Mary",
            message: "I read after school. It helps me relax.",
            audio: "level13P5Audio8",
          },
          {
            role: "System",
            name: "Girish",
            message:
              "Storybooks make us think and laugh. Let’s exchange books next week.",
            audio: "level13P5Audio9",
          },
          {
            role: "User",
            name: "Mary",
            message: "I’ll bring my favourite one.",
            audio: "level13P5Audio10",
          },
          {
            role: "System",
            name: "Girish",
            message: "Me too! See you tomorrow!",
            audio: "level13P5Audio11",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What story did Mary read recently?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "The Clever Fox",
            },
            {
              type: "text",
              id: "option2",
              value: "The Brave Lion",
            },
            {
              type: "text",
              id: "option3",
              value: "Tenali Raman’s Trick",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What happens at the end of Mary’s story?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "The fox tricks the lion",
            },
            {
              type: "text",
              id: "option2",
              value: "The lion wins the fight",
            },
            {
              type: "text",
              id: "option3",
              value: "The fox runs away scared",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "When does Girish usually read books?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Before going to bed",
            },
            {
              type: "text",
              id: "option2",
              value: "During lunch time",
            },
            {
              type: "text",
              id: "option3",
              value: "In the morning",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "Why does Mary read storybooks after school?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "It helps her relax",
            },
            {
              type: "text",
              id: "option2",
              value: "It helps her run faster",
            },
            {
              type: "text",
              id: "option3",
              value: "It helps her write stories",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What do Girish and Mary plan to do next week?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Exchange books",
            },
            {
              type: "text",
              id: "option2",
              value: "Write a story",
            },
            {
              type: "text",
              id: "option3",
              value: "Visit the library",
            },
          ],
          answer: "option1",
        },
      ],
    },
  },
  {
    level: "P6",
    mechanics: "whatsMissing",
    data: {
      data: [
        {
          question: "I need to buy a new ___________ for my tennis practice.",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "racketImg", text: "Racket" },
            { img: "netImg", text: "Net" },
            { img: "batImg", text: "Bat" },
          ],
          correctAnswer: "Racket",
          hints: "Used to hit the tennis ball.",
        },
        {
          question: "I practice at the _________ near my home.",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "mall3Img", text: "mall" },
            { img: "stadiumImg", text: "stadium" },
            { img: "restaurant2Img", text: "restaurant" },
          ],
          correctAnswer: "stadium",
          hints: "A large area where sports happen.",
        },
        // {
        //   question: "I jog for about ________ minutes every morning.",
        //   finalQuestion: "Read the word you chose",
        //   allwords: [
        //     { img: "thirtyImg", text: "Thirty" },
        //     { img: "fiveImg", text: "Five" },
        //     { img: "sixtyImg", text: "Sixty" },
        //   ],
        //   correctAnswer: "Thirty",
        //   hints: "It is half of sixty.",
        // },
        {
          question:
            "I have a very good _________________ who helps me train well.",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "teacher2Img", text: "teacher" },
            { img: "doctor2Img", text: "doctor" },
            { img: "coachImg", text: "coach" },
          ],
          correctAnswer: "coach",
          hints: "Guides and trains players.",
        },
        {
          question: "I carry a bottle of ________ and a napkin in my backpack.",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "water2Img", text: "water" },
            { img: "juice2Img", text: "juice" },
            { img: "milk2Img", text: "milk" },
          ],
          correctAnswer: "water",
          hints: "It is essential for hydration.",
        },
        {
          question:
            "After one hour of rigorous tennis practice, I prefer to eat a healthy _________________",
          finalQuestion: "Read the word you chose",
          allwords: [
            { img: "breakfastImg", text: "breakfast" },
            { img: "milk2Img", text: "milk" },
            { img: "burger2Img", text: "burger" },
          ],
          correctAnswer: "breakfast",
          hints: "First meal of the day.",
        },
        // {
        //   question: "I usually jog at the ________ near my house.",
        //   finalQuestion: "Read the word you chose",
        //   allwords: [
        //     { img: "parkImg", text: "Park" },
        //     { img: "mallImg", text: "Mall" },
        //     { img: "officeImg", text: "Office" },
        //   ],
        //   correctAnswer: "Park",
        //   hints: "This place has trees and walking paths.",
        // },
      ],
    },
  },
  {
    level: "P7",
    mechanics: "arrangePicture",
    data: {
      images: [
        { img: "butterfly1Img", id: "1" },
        { img: "butterfly4Img", id: "4" },
        { img: "butterfly3Img", id: "3" },
        { img: "butterfly5Img", id: "5" },
        { img: "butterfly2Img", id: "2" },
      ],
      audioData: [
        {
          audio: "butterflyOneAudio",
          text: "Two children find a cute green caterpillar on a plant. They are excited and look at it with curiosity.",
        },
        {
          audio: "butterflyTwoAudio",
          text: "The girl gently places the caterpillar into a small jar.  Both children smile happily as they watch it move inside.",
        },
        {
          audio: "butterflyThreeAudio",
          text: "At home, the girl carefully adds fresh leaves to the jar.  The boy holds the lid and watches her with interest.",
        },
        {
          audio: "butterflyFourAudio",
          text: "One day, the caterpillar becomes a colourful butterfly.  The children and their mother watch it fly out of the window.",
        },
      ],
    },
  },
  {
    level: "P8",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "anouncement",
        imageOne: "roadSafetyImg1",
        imageTwo: "roadSafetyImg2",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "Road safety saves lives.Wear a seatbelt in cars and a helmet on bikes. Use zebra crossings and always walk on the footpath. Never use your phone while driving—it causes accidents. Follow traffic signals and look both ways before crossing. Ignoring safety rules can lead to serious injury or death. Stay alert and protect yourself and others.",
            audio: "roadSafety2Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Why should you wear a seatbelt in a car?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "It helps you relax",
            },
            {
              type: "text",
              id: "option2",
              value: "It protects you in an accident",
            },
            {
              type: "text",
              id: "option3",
              value: "It keeps the car clean",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What should you wear while riding a bike?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A cap",
            },
            {
              type: "text",
              id: "option2",
              value: "A helmet",
            },
            {
              type: "text",
              id: "option3",
              value: "A scarf",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Where should you cross the road safely?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "At the zebra crossing",
            },
            {
              type: "text",
              id: "option2",
              value: "Between moving cars",
            },
            {
              type: "text",
              id: "option3",
              value: "Near a parked bus",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: " Why should you not use your phone while driving?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "It distracts and causes accidents",
            },
            {
              type: "text",
              id: "option2",
              value: "It saves fuel",
            },
            {
              type: "text",
              id: "option3",
              value: "It helps you park",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What can happen if you ignore road safety rules?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "You get more time",
            },
            {
              type: "text",
              id: "option2",
              value: "You may win a race",
            },
            {
              type: "text",
              id: "option3",
              value: "You may get injured or die",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "S2",
    mechanics: "ReadAloudMcqM10",
    data: {
      instructions: {
        type: "chat",
        completeAudio: "level13S2CAudio",
        content: [
          {
            role: "System",
            name: "Conductor",
            message: "Hello, where are you going?",
            audio: "level13S2Audio1",
          },
          {
            role: "User",
            name: "Fareed",
            message: "I’m going to Hockey Stadium, Uncle.",
            audio: "level13S2Audio2",
          },
          {
            role: "System",
            name: "Conductor",
            message: "The ticket is twenty rupees.",
            audio: "level13S2Audio3",
          },
          {
            role: "User",
            name: "Fareed",
            message: "Here’s fifty rupees, please give me change.",
            audio: "level13S2Audio4",
          },
          {
            role: "System",
            name: "Conductor",
            message: "Here’s your ticket and change.",
            audio: "level13S2Audio5",
          },
          {
            role: "System",
            name: "Conductor",
            message: "Why are you going there?",
            audio: "level13S2Audio6",
          },
          {
            role: "User",
            name: "Fareed",
            message: "There’s a hockey match at the stadium.",
            audio: "level13S2Audio7",
          },
          {
            role: "System",
            name: "Conductor",
            message: "Are you going alone?",
            audio: "level13S2Audio8",
          },
          {
            role: "User",
            name: "Fareed",
            message: "Yes, my friends are waiting there.",
            audio: "level13S2Audio9",
          },
          {
            role: "System",
            name: "Conductor",
            message: "Be careful and enjoy the match.",
            audio: "level13S2Audio10",
          },
          {
            role: "User",
            name: "Fareed",
            message: "I will, thank you!",
            audio: "level13S2Audio11",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Where is Fareed going?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "City Mall",
            },
            {
              type: "text",
              id: "option2",
              value: "Bus Station",
            },
            {
              type: "text",
              id: "option3",
              value: "Hockey Stadium",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "How much is the bus ticket?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Fifteen rupees",
            },
            {
              type: "text",
              id: "option2",
              value: "Twenty rupees",
            },
            {
              type: "text",
              id: "option3",
              value: "Thirty rupees",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "How much money does Fareed give the conductor?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Fifteen rupees",
            },
            {
              type: "text",
              id: "option2",
              value: "Fifty rupees",
            },
            {
              type: "text",
              id: "option3",
              value: "Thirty rupees",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What match is being played at the stadium?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Football",
            },
            {
              type: "text",
              id: "option2",
              value: "Hockey",
            },
            {
              type: "text",
              id: "option3",
              value: "Movie show",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Who is waiting for Fareed?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "His parents",
            },
            {
              type: "text",
              id: "option2",
              value: "His friends",
            },
            {
              type: "text",
              id: "option3",
              value: "His uncle",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
];

export const level12 = [
  {
    level: "P1",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "banyanTreeImg",
        imageTwo: "mall2Img",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "You start at the bus stop near the mall. Walk straight along MG Road for about five minutes. You will see a bookstore on your left and a bakery on your right. Keep walking until you reach the traffic signal. Turn left at the signal and walk for 100 meters. The stadium is next to a big banyan tree.",
            audio: "level12P1Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Where do you start your walk?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "At the mall",
            },
            {
              type: "text",
              id: "option2",
              value: "At the bus stop near the mall",
            },
            {
              type: "text",
              id: "option3",
              value: "At the stadium",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What road do you walk along first?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "MG Road",
            },
            {
              type: "text",
              id: "option2",
              value: "Main Road",
            },
            {
              type: "text",
              id: "option3",
              value: "Park Street",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What do you see on your right after five minutes?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A bookstore",
            },
            {
              type: "text",
              id: "option2",
              value: "A bakery",
            },
            {
              type: "text",
              id: "option3",
              value: "A hospital",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What should you do at the traffic signal?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Turn left",
            },
            {
              type: "text",
              id: "option2",
              value: "Go straight",
            },
            {
              type: "text",
              id: "option3",
              value: "Turn right",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "Where is the stadium located?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Next to a school",
            },
            {
              type: "text",
              id: "option2",
              value: "Behind a shop",
            },
            {
              type: "text",
              id: "option3",
              value: "Next to a big banyan tree",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "P2",
    mechanics: "ReadAloudMcqM10",
    data: {
      instructions: {
        type: "chat",
        completeAudio: "level12P2CAudio",
        content: [
          {
            role: "System",
            name: "Mary",
            message:
              "Hi Ravi, you threw the banana peel in the classroom corner!",
            audio: "level12P2Audio_1",
          },
          {
            role: "User",
            name: "Ravi",
            message: "Oh! I didn’t think anyone would notice it.",
            audio: "level12P2Audio_2",
          },
          {
            role: "System",
            name: "Mary",
            message: "That’s not right. Please use the dustbin.",
            audio: "level12P2Audio_3",
          },
          {
            role: "User",
            name: "Ravi",
            message: "I’m sorry. You are right, Mary.",
            audio: "level12P2Audio_4",
          },
          {
            role: "System",
            name: "Mary",
            message:
              "Keeping our classroom clean is very important. Also, we should segregate wet and dry waste.",
            audio: "level12P2Audio_5",
          },
          {
            role: "User",
            name: "Ravi",
            message:
              "Clean places help us stay healthy and happy. Let’s remind others to use the dustbin too.",
            audio: "level12P2Audio_6",
          },
          {
            role: "System",
            name: "Mary",
            message: "Good idea. We should all care for our school.",
            audio: "level12P2Audio_7",
          },
          {
            role: "User",
            name: "Ravi",
            message: "A Clean school means safe and happy learning.",
            audio: "level12P2Audio_8",
          },
          {
            role: "System",
            name: "Mary",
            message: "I agree. Let’s set a good example.",
            audio: "level12P2Audio_9",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What did Mary see Ravi do in the classroom?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Throw a banana peel in the corner",
            },
            {
              type: "text",
              id: "option2",
              value: "Write on the wall",
            },
            {
              type: "text",
              id: "option3",
              value: "Hide under the table",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What does Mary ask Ravi to use?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "The washroom",
            },
            {
              type: "text",
              id: "option2",
              value: "The blackboard",
            },
            {
              type: "text",
              id: "option3",
              value: "The dustbin",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What advice does Mary give about waste?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Burn all the waste",
            },
            {
              type: "text",
              id: "option2",
              value: "Segregate wet and dry waste",
            },
            {
              type: "text",
              id: "option3",
              value: "Throw everything together",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Why does Mary say clean places are important?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "They look pretty",
            },
            {
              type: "text",
              id: "option2",
              value: "They help us stay healthy and happy",
            },
            {
              type: "text",
              id: "option3",
              value: "They save money",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What do Ravi and Mary want to do for their school?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Decorate it with posters",
            },
            {
              type: "text",
              id: "option2",
              value: "Set a good example",
            },
            {
              type: "text",
              id: "option3",
              value: "Buy a new dustbin",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
  {
    level: "P4",
    mechanics: "jumbledWord",
    data: [
      {
        correctWord: [
          {
            audio: "level12P4OneAudio",
            correctSentence:
              "Flight 284E to Hyderabad will begin boarding at Gate 9 in 10 minutes. Keep your ID ready.",
          },
        ],
        jumbledWords: [
          "in",
          "Gate 9",
          "10 minutes.",
          "to Hyderabad",
          "your ID",
          "boarding at",
          "Flight 284E",
          "ready.",
          "Keep",
          "will begin",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P4TwoAudio",
            correctSentence:
              "The stadium front gates open at 3:00 PM. The match begins at 4:00 PM sharp.",
          },
        ],
        jumbledWords: [
          "begins at",
          "3:00 PM.",
          "The stadium",
          "sharp.",
          "open at",
          "4:00 PM",
          "front gates",
          "The match",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P4ThreeAudio",
            correctSentence:
              "Please take your seats and turn off your mobile devices. The show will begin in 5 minutes.",
          },
        ],
        jumbledWords: [
          "off your mobile",
          "Please take",
          "devices.",
          "will begin",
          "and turn",
          "in 5 minutes.",
          "your seats",
          "The show",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P4FourAudio",
            correctSentence:
              "Our annual sales start at 4 PM today on the second floor. Don’t miss the offers!",
          },
        ],
        jumbledWords: [
          "start at",
          "the offers!",
          "on the",
          "today",
          "Our",
          "Don’t miss",
          "annual sales",
          "4 PM",
          "second floor.",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P4FiveAudio",
            correctSentence:
              "Welcome to the Sompura Village Fair! Cultural performances will begin at 6 PM.",
          },
        ],
        jumbledWords: [
          "6 PM.",
          "Cultural performances",
          "Welcome to",
          "at",
          "Fair!",
          "will begin",
          "the Sompura Village",
        ],
      },
    ],
  },
  {
    level: "P3",
    mechanics: "jumbledWord",
    data: [
      {
        correctWord: [
          {
            audio: "level12P3OneAudio",
            correctSentence:
              "Fluffy white clouds drift across a beautiful, clear blue sky.",
          },
        ],
        jumbledWords: [
          "clouds",
          "beautiful,",
          "Fluffy white",
          "sky.",
          "drift across",
          "clear blue",
          "a",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P3TwoAudio",
            correctSentence:
              "The turtle has a large, hard brown shell that protects its body.",
          },
        ],
        jumbledWords: [
          "protects its",
          "body.",
          "large,",
          "shell that",
          "The turtle",
          "has a",
          "hard brown",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P3ThreeAudio",
            correctSentence:
              "Two young boys are kicking a soccer ball during a friendly game.",
          },
        ],
        jumbledWords: [
          "kicking a",
          "game.",
          "boys",
          "soccer ball",
          "during a",
          "are",
          "friendly",
          "Two young",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P3FourAudio",
            correctSentence:
              "There are three ripe, juicy red tomatoes with green stems.",
          },
        ],
        jumbledWords: [
          "tomatoes with",
          "juicy red",
          "There are",
          "three",
          "green",
          "ripe,",
          "stems.",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P3FiveAudio",
            correctSentence:
              "A large cobra, with its hood raised, rests on a patch of green grass.",
          },
        ],
        jumbledWords: [
          "rests on",
          "grass.",
          "of green",
          "A large",
          "cobra,",
          "hood",
          "a patch",
          "raised,",
          "with its",
        ],
      },
    ],
  },
  {
    level: "S1",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "Go straight on Kasturba Road. Walk past the post office and turn left. After about 100 meters, you will see a supermarket. Cross the road at the zebra crossing and keep walking until you see a park. Take the first right. The city library is next to the State Bank of India.",
            audio: "KasturbaRoadAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Which road should you walk along at the beginning?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "MG Road",
            },
            {
              type: "text",
              id: "option2",
              value: "Kasturba Road",
            },
            {
              type: "text",
              id: "option3",
              value: "Nehru Street",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What landmark do you pass before turning left?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Post office",
            },
            {
              type: "text",
              id: "option2",
              value: "Supermarket",
            },
            {
              type: "text",
              id: "option3",
              value: "Bakery",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "How far do you walk before reaching the supermarket?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Around 100 meters",
            },
            {
              type: "text",
              id: "option2",
              value: "Half a kilometer",
            },
            {
              type: "text",
              id: "option3",
              value: "One kilometer",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "Where do you cross the road?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "At the traffic light",
            },
            {
              type: "text",
              id: "option2",
              value: "At the zebra crossing",
            },
            {
              type: "text",
              id: "option3",
              value: "At the bus stop",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What is next to the city library?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A school",
            },
            {
              type: "text",
              id: "option2",
              value: "A coffee shop",
            },
            {
              type: "text",
              id: "option3",
              value: "The State Bank of India",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "P5",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "anouncement",
        imageOne: "banyanTreeImg",
        imageTwo: "mall2Img",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "Go straight along Kasturba Road. Walk past the post office and turn left. After approximately 100 meters, you will come to a supermarket. Cross the road at the zebra crossing and keep walking until you reach a park. Take the first right, and you will find the city library next to the State Bank of India.",
            audio: "KasturbaRoad2Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Which street do you take first?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Main Road",
            },
            {
              type: "text",
              id: "option2",
              value: "MG Street",
            },
            {
              type: "text",
              id: "option3",
              value: "Highway Road",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: " How far should you walk after turning at the signal?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "100 meters",
            },
            {
              type: "text",
              id: "option2",
              value: "500 meters",
            },
            {
              type: "text",
              id: "option3",
              value: "One kilometre",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What is located next to the stadium?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A library",
            },
            {
              type: "text",
              id: "option2",
              value: "A big coffee shop",
            },
            {
              type: "text",
              id: "option3",
              value: "A supermarket",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: " What kind of tree is in front of the stadium?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A mango tree",
            },
            {
              type: "text",
              id: "option2",
              value: "A banyan tree",
            },
            {
              type: "text",
              id: "option3",
              value: "A palm tree",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What makes the stadium easy to identify?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Its tall walls",
            },
            {
              type: "text",
              id: "option2",
              value: "Its loud music",
            },
            {
              type: "text",
              id: "option3",
              value: "Its large red sign",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "P6",
    mechanics: "ReadAloudMcqM10",
    data: {
      instructions: {
        type: "chat",
        completeAudio: "level12P6CAudio",
        content: [
          {
            role: "System",
            name: "Nafisa",
            message: "Hi Harish, how is your exam preparation going?",
            audio: "level12P6Audio_1",
          },
          {
            role: "User",
            name: "Harish",
            message: "Hi Nafisa, it’s going well. I wake up early to study.",
            audio: "level12P6Audio_2",
          },
          {
            role: "System",
            name: "Nafisa",
            message: "That’s good. I read one subject each evening.",
            audio: "level12P6Audio_3",
          },
          {
            role: "User",
            name: "Harish",
            message: "I do maths in the morning. It’s easier then.",
            audio: "level12P6Audio_4",
          },
          {
            role: "System",
            name: "Nafisa",
            message: "Yes, morning is a good time to study.",
            audio: "level12P6Audio_5",
          },
          {
            role: "User",
            name: "Harish",
            message: "I also make notes while reading chapters.",
            audio: "level12P6Audio_6",
          },
          {
            role: "System",
            name: "Nafisa",
            message: "That helps me too. I write key points.",
            audio: "level12P6Audio_7",
          },
          {
            role: "User",
            name: "Harish",
            message: "I also revise with my sister on weekends.",
            audio: "level12P6Audio_8",
          },
          {
            role: "System",
            name: "Nafisa",
            message: "I ask my mother to quiz me sometimes.",
            audio: "level12P6Audio_9",
          },
          {
            role: "User",
            name: "Harish",
            message: "That’s a smart idea. I will try that.",
            audio: "level12P6Audio_10",
          },
          {
            role: "System",
            name: "Nafisa",
            message: "All the best for your exams, Harish!",
            audio: "level12P6Audio_11",
          },
          {
            role: "User",
            name: "Harish",
            message: "Thanks, Nafisa. Good luck to you too!",
            audio: "level12P6Audio_12",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What time does Harish study?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "At night",
            },
            {
              type: "text",
              id: "option2",
              value: "In the afternoon",
            },
            {
              type: "text",
              id: "option3",
              value: "In the morning",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What subject does Harish study in the morning?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Maths",
            },
            {
              type: "text",
              id: "option2",
              value: "English",
            },
            {
              type: "text",
              id: "option3",
              value: "Science",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What does Nafisa do in the evening?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "She watches TV",
            },
            {
              type: "text",
              id: "option2",
              value: "She reads one subject",
            },
            {
              type: "text",
              id: "option3",
              value: "She plays games",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Who helps Harish revise?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "His brother",
            },
            {
              type: "text",
              id: "option2",
              value: "His sister",
            },
            {
              type: "text",
              id: "option3",
              value: "His friend",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "How does Nafisa practise for exams?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Takes tests",
            },
            {
              type: "text",
              id: "option2",
              value: "Uses flashcards",
            },
            {
              type: "text",
              id: "option3",
              value: "Asks her mother to quiz her",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "P7",
    mechanics: "jumbledWord",
    data: [
      {
        correctWord: [
          {
            audio: "level12P7OneAudio",
            correctSentence:
              "Red and white flowers grow around a small, tranquil pond.",
          },
        ],
        jumbledWords: [
          "pond.",
          "and",
          "white flowers",
          "around",
          "small, tranquil",
          "grow",
          "a",
          "Red",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P7TwoAudio",
            correctSentence:
              "Rain falls from dark grey clouds in a gentle shower.",
          },
        ],
        jumbledWords: [
          "shower.",
          "dark grey",
          "falls from",
          "clouds in",
          "a gentle",
          "Rain",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P7ThreeAudio",
            correctSentence:
              "A young boy enjoys a bowl of delicious-looking soup at a table.",
          },
        ],
        jumbledWords: [
          "young boy",
          "delicious-looking",
          "soup",
          "a bowl",
          "enjoys",
          "at a",
          "table.",
          "of",
          "A",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P7FourAudio",
            correctSentence:
              "This is a big, ripe red tomato, possibly suggesting freshness.",
          },
        ],
        jumbledWords: [
          "freshness.",
          "possibly suggesting",
          "ripe red",
          "tomato,",
          "big,",
          "This",
          "is",
          "a",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P7FiveAudio",
            correctSentence:
              "A beautiful small weaver bird is carefully sitting on its nest.",
          },
        ],
        jumbledWords: [
          "nest.",
          "weaver bird",
          "beautiful small",
          "carefully sitting",
          "on its",
          "A",
          "is",
        ],
      },
    ],
  },
  {
    level: "P8",
    mechanics: "jumbledWord",
    data: [
      {
        correctWord: [
          {
            audio: "level12P8OneAudio",
            correctSentence:
              "Try our special dish today, grilled salmon and mashed potatoes.",
          },
        ],
        jumbledWords: [
          "today,",
          "mashed potatoes.",
          "Try our",
          "and",
          "special dish",
          "grilled salmon",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P8TwoAudio",
            correctSentence:
              "Enjoy 30% off on all fresh fruits and vegetables today only!",
          },
        ],
        jumbledWords: [
          "fresh fruits",
          "and vegetables",
          "30% off",
          "on all",
          "today only!",
          "Enjoy",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P8ThreeAudio",
            correctSentence:
              "The library will close in 15 minutes. Please return all the books now.",
          },
        ],
        jumbledWords: [
          "in 15 minutes.",
          "will close",
          "all the books",
          "Please return",
          "now.",
          "The library",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P8FourAudio",
            correctSentence:
              "Train number 2564 to Indore will depart in 10 minutes from Platform 7.",
          },
        ],
        jumbledWords: [
          "10 minutes",
          "2564",
          "Train number",
          "to Indore",
          "Platform 7.",
          "in",
          "will depart",
          "from",
        ],
      },
      {
        correctWord: [
          {
            audio: "level12P8FiveAudio",
            correctSentence:
              "The play will begin in 5 minutes. Kindly take your seats and switch off your phones.",
          },
        ],
        jumbledWords: [
          "in 5",
          "your",
          "switch off",
          "and",
          "minutes.",
          "phones.",
          "Kindly take",
          "The play",
          "will begin",
          "your seats",
        ],
      },
    ],
  },
  {
    level: "S2",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "anouncement",
        imageOne: "PlanetariumImg",
        imageTwo: "ChildrensParkImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "Attention everyone! If you're going to the Tara planetarium, take bus number 8 from the bus stop near Childrens Park. Get off at MG Road and walk straight for 3 minutes. The planetarium is located on your left, just after the large bookshop. Keep your tickets ready. A show begins every hour, so arrive early if you’d like to attend.",
            audio: "TaraPlanetariumAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Which bus should you take to reach the Tara planetarium?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Bus Number 5",
            },
            {
              type: "text",
              id: "option2",
              value: "Bus Number 8",
            },
            {
              type: "text",
              id: "option3",
              value: "Bus Number 10",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Where is the bus stop located?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Near MG Road",
            },
            {
              type: "text",
              id: "option2",
              value: "Near Green Park",
            },
            {
              type: "text",
              id: "option3",
              value: "Near the planetarium",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What should you do after getting off the bus?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Walk straight for 3 minutes",
            },
            {
              type: "text",
              id: "option2",
              value: "Turn right at the corner",
            },
            {
              type: "text",
              id: "option3",
              value: "Take another bus",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What landmark is near the planetarium?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A coffee shop",
            },
            {
              type: "text",
              id: "option2",
              value: "A large bookshop",
            },
            {
              type: "text",
              id: "option3",
              value: "A railway station",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Why should visitors arrive early at the planetarium?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "To buy snacks",
            },
            {
              type: "text",
              id: "option2",
              value: "To get good seats",
            },
            {
              type: "text",
              id: "option3",
              value: "To attend the hourly show",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
];

export const level11 = [
  {
    level: "P1",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "girlTVImg",
        imageTwo: "girlcycleImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "I love idli and chocolates. I don’t like junk food. I enjoy watching animal cartoons on TV. I like playing hockey. I don’t like waking up early. I love reading picture storybooks. My favourite colour is red. I don’t enjoy listening to loud music. I like cycling in the morning.",
            audio: "level11P1Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What food does the person love?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Chocolates",
            },
            {
              type: "text",
              id: "option2",
              value: "Vegetables",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What food does the person dislike?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Idli",
            },
            {
              type: "text",
              id: "option2",
              value: "Junk food",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What kind of TV shows does the person enjoy?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Animal cartoons",
            },
            {
              type: "text",
              id: "option2",
              value: "Cooking shows",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "Which sport does the person like?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Hockey",
            },
            {
              type: "text",
              id: "option2",
              value: "Football",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What does the person not like doing in the morning?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Waking up early",
            },
            {
              type: "text",
              id: "option2",
              value: "Eating breakfast",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What is the person’s favourite colour?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Green",
            },
            {
              type: "text",
              id: "option2",
              value: "Red",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
  {
    level: "P2",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "boyfootballImg",
        imageTwo: "govschoolImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "My best friend is Ramesh. He is short and has curly hair. He is kind and funny. We study in the Government High School. Our school has ten classrooms. There is a library with a wide selection of children's storybooks. The playground is adjacent to the school. We play football there. Our teachers are friendly and guide us.",
            audio: "level11P2Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Who is the person’s best friend?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Ravi",
            },
            {
              type: "text",
              id: "option2",
              value: "Ramesh",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What kind of hair does the person’s friend have?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Curly hair",
            },
            {
              type: "text",
              id: "option2",
              value: "Straight hair",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "How is the person’s friend described?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Kind and funny",
            },
            {
              type: "text",
              id: "option2",
              value: "Strict and serious",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "Where does the person study?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Private school",
            },
            {
              type: "text",
              id: "option2",
              value: "Government High School",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Where is the playground located?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Next to the school",
            },
            {
              type: "text",
              id: "option2",
              value: "Far from the school",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "How many classrooms does the school have?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Ten",
            },
            {
              type: "text",
              id: "option2",
              value: "Twenty",
            },
          ],
          answer: "option1",
        },
      ],
    },
  },
  {
    level: "P3",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "vegVendor",
        imageTwo: "thingirlImg",
      },
      conversation: [
        {
          speaker: "Good morning, dear! What do you want?",
          user: "Good morning, sir. I need some carrots.",
          audio: "level11P3OneUAudio",
          speakerAudio: "level11P3OneSAudio",
        },
        {
          speaker: "How many kilos do you want?",
          user: "One kilogram, please.",
          audio: "level11P3TwoUAudio",
          speakerAudio: "level11P3TwoSAudio",
        },
        {
          speaker: "One kilo of carrots costs Rs. 80.",
          user: "That’s fine. I also need half a kilo of cucumber and beans.",
          audio: "level11P3ThreeUAudio",
          speakerAudio: "level11P3ThreeSAudio",
        },
        {
          speaker: "Anything else?",
          user: "No, that’s all. What is the total amount?",
          audio: "level11P3FourUAudio",
          speakerAudio: "level11P3FourSAudio",
        },
        {
          speaker: "The total amount is Rs. 150.",
          user: "Here is the money. Thank you, sir.",
          audio: "level11P3FiveUAudio",
          speakerAudio: "level11P3FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P4",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "motherImg",
        imageTwo: "kidImg",
      },
      conversation: [
        {
          speaker: "Giri, can you help me in the kitchen?",
          user: "Sure, Mom! What should I do?",
          audio: "level11P4OneUAudio",
          speakerAudio: "level11P4OneSAudio",
        },
        {
          speaker: "Please bring me the carrots from the fridge.",
          user: "Here they are, Mom. Do you need anything else?",
          audio: "level11P4TwoUAudio",
          speakerAudio: "level11P4TwoSAudio",
        },
        {
          speaker: "Yes, wash these vegetables and put them in the basket.",
          user: "Okay, I have washed them. What’s next?",
          audio: "level11P4ThreeUAudio",
          speakerAudio: "level11P4ThreeSAudio",
        },
        {
          speaker: "Can you get me the tamarind from the shelf?",
          user: "Here it is, Mom. Are you making sambar?",
          audio: "level11P4FourUAudio",
          speakerAudio: "level11P4FourSAudio",
        },
        {
          speaker: "Yes, and your favourite papad too!",
          user: "Wow! I can’t wait to eat. Thank you, Mom!",
          audio: "level11P4FiveUAudio",
          speakerAudio: "level11P4FiveSAudio",
        },
      ],
    },
  },
  {
    level: "S1",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "FamilyTVImg",
        imageTwo: "familyFoodImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "I enjoy a healthy breakfast with fruits and eggs. Sometimes, I eat dosa. I eat with my parents before school. I love watching movies with my family. I enjoy cartoons. I also love reading picture storybooks. The illustrations help me imagine the story. I don’t enjoy horror movies.",
            audio: "level11S1Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What does the person eat for breakfast?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Fruits and eggs",
            },
            {
              type: "text",
              id: "option2",
              value: "Only dosa",
            },
            {
              type: "text",
              id: "option3",
              value: "Just milk.",
            },
            {
              type: "text",
              id: "option4",
              value: "Only bread",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "When does the person eat with their parents?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "After school",
            },
            {
              type: "text",
              id: "option2",
              value: "Before school",
            },
            {
              type: "text",
              id: "option3",
              value: "During lunch",
            },
            {
              type: "text",
              id: "option4",
              value: "Midnight",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What kind of movies does the person enjoy?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Horror movies",
            },
            {
              type: "text",
              id: "option2",
              value: "Action movies",
            },
            {
              type: "text",
              id: "option3",
              value: "Movies with family",
            },
            {
              type: "text",
              id: "option4",
              value: "Cooking shows",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What helps the person imagine the story in books?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "The cover",
            },
            {
              type: "text",
              id: "option2",
              value: "The title",
            },
            {
              type: "text",
              id: "option3",
              value: "The illustrations",
            },
            {
              type: "text",
              id: "option4",
              value: "They are for exams",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What type of movies does the person not enjoy?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Cartoons",
            },
            {
              type: "text",
              id: "option2",
              value: "Horror movies",
            },
            {
              type: "text",
              id: "option3",
              value: "Adventure movies",
            },
            {
              type: "text",
              id: "option4",
              value: "Science fiction movies",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Which food does the person sometimes eat for breakfast?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Dosa",
            },
            {
              type: "text",
              id: "option2",
              value: "Pizza",
            },
            {
              type: "text",
              id: "option3",
              value: "Burgers",
            },
            {
              type: "text",
              id: "option4",
              value: "Ice cream",
            },
          ],
          answer: "option1",
        },
      ],
    },
  },
  {
    level: "P5",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "girlcycleImg",
        imageTwo: "girlTVImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "I love idli and chocolates. I don’t like junk food. I enjoy watching animal cartoons. I like playing hockey. I don’t like waking up early. I love reading picture storybooks. My favourite colour is red. I don’t enjoy listening to loud music. I like cycling in the morning.",
            audio: "level11P5Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What type of books does the person love to read?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Story books",
            },
            {
              type: "text",
              id: "option2",
              value: "Picture storybooks",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What is the person’s favourite colour?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Red",
            },
            {
              type: "text",
              id: "option2",
              value: "Blue",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What kind of music does the person not enjoy?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Loud music",
            },
            {
              type: "text",
              id: "option2",
              value: "Soft music",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What activity does the person enjoy in the morning?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Cycling",
            },
            {
              type: "text",
              id: "option2",
              value: "Watching cartoons",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What does the person love besides chocolates?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Idli",
            },
            {
              type: "text",
              id: "option2",
              value: "Burger",
            },
          ],
          answer: "option1",
        },
      ],
    },
  },
  {
    level: "P6",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "boyfootballImg",
        imageTwo: "govschoolImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "My best friend is Ramesh. He is short and has curly hair. He is kind and funny. We study in the Government High School. Our school has ten classrooms. There is a library with a wide selection of children's storybooks. The playground is adjacent to the school. We play football there. Our teachers are friendly and guide us.",
            audio: "level11P6Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What kind of books are in the school library?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Science books",
            },
            {
              type: "text",
              id: "option2",
              value: "Children's storybooks",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Where is the school playground?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Far from the school",
            },
            {
              type: "text",
              id: "option2",
              value: "Next to the school",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What game do the students play on the playground?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Football",
            },
            {
              type: "text",
              id: "option2",
              value: "Cricket",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What are the teachers like, according to the person?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Strict and rude",
            },
            {
              type: "text",
              id: "option2",
              value: "Friendly and helpful",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What do the teachers do for the person?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Give gifts",
            },
            {
              type: "text",
              id: "option2",
              value: "Guide them",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
  {
    level: "P7",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "manImg",
        imageTwo: "UniversityGirlImg",
      },
      conversation: [
        {
          speaker: "Good morning! How can I help you?",
          user: "Good morning, sir. I need a dairy and pens.",
          audio: "level11P7OneUAudio",
          speakerAudio: "level11P7OneSAudio",
        },
        {
          speaker: "What type of dairy do you need?",
          user: "A dairy with month and day-wise pages.  How much does it cost?",
          audio: "level11P7TwoUAudio",
          speakerAudio: "level11P7TwoSAudio",
        },
        {
          speaker: "It costs Rs. 100. How many pens do you want?",
          user: "One blue pens and one black pen, please.",
          audio: "level11P7ThreeUAudio",
          speakerAudio: "level11P7ThreeSAudio",
        },
        {
          speaker: "Anything else?",
          user: "No, that’s all. What is the total amount?",
          audio: "level11P7FourUAudio",
          speakerAudio: "level11P7FourSAudio",
        },
        {
          speaker: "The total is Rs. 160.",
          user: "Please take this money. Thank you, sir!",
          audio: "level11P7FiveUAudio",
          speakerAudio: "level11P7FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P8",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "manImg",
        imageTwo: "thingirlImg",
      },
      conversation: [
        {
          speaker: "Mary, are you ready for the movie?",
          user: "Yes, Dad! But I can’t find my shoes.",
          audio: "level11P8OneUAudio",
          speakerAudio: "level11P8OneSAudio",
        },
        {
          speaker: "Check in the shoe rack. Are they there?",
          user: "No, I don’t see them",
          audio: "level11P8TwoUAudio",
          speakerAudio: "level11P8TwoSAudio",
        },
        {
          speaker: "Look behind the door. I think I saw them there.",
          user: "Oh yes! Here it is. Thank you, Dad.",
          audio: "level11P8ThreeUAudio",
          speakerAudio: "level11P8ThreeSAudio",
        },
        {
          speaker: "Good! Do you have your water bottle and popcorn?",
          user: "Yes, everything is ready.",
          audio: "level11P8FourUAudio",
          speakerAudio: "level11P8FourSAudio",
        },
        {
          speaker: "Great! Let’s leave early to get good seats.",
          user: "Okay, Dad! Let’s go.",
          audio: "level11P8FiveUAudio",
          speakerAudio: "level11P8FiveSAudio",
        },
      ],
    },
  },
  {
    level: "S2",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "thingirlImg",
        imageTwo: "cat2Image",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "My name is Deepa. I have a small cat. She has white and grey stripes. She is very fluffy. I like to play with my cat. She likes to sleep. When she sees a rat, she chases it.",
            audio: "level11S2Audio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What is the girl's name?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Deepa",
            },
            {
              type: "text",
              id: "option2",
              value: "Reema",
            },
            {
              type: "text",
              id: "option3",
              value: "Meena",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What pet does Deepa have?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A dog",
            },
            {
              type: "text",
              id: "option2",
              value: "A cat",
            },
            {
              type: "text",
              id: "option3",
              value: "A rabbit",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What colors are on Deepa’s cat?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Black and white",
            },
            {
              type: "text",
              id: "option2",
              value: "Brown and orange",
            },
            {
              type: "text",
              id: "option3",
              value: "White and grey",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What does the cat do when it sees a rat?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Sleeps",
            },
            {
              type: "text",
              id: "option2",
              value: "Chases it",
            },
            {
              type: "text",
              id: "option3",
              value: "Runs away",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What does Deepa like to do with her cat?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Play with it",
            },
            {
              type: "text",
              id: "option2",
              value: "Feed it",
            },
            {
              type: "text",
              id: "option3",
              value: "Take it for a walk",
            },
          ],
          answer: "option1",
        },
      ],
    },
  },
];

export const level15 = [
  {
    level: "P1",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "boyChild2Img",
        imageTwo: "UniversityGirlImg",
      },
      conversation: [
        {
          speaker: "Hi, how is your university?",
          user: "It’s big and full of smart students.",
          audio: "level15P1OneUAudio",
          speakerAudio: "level15P1OneSAudio",
        },
        {
          speaker: "Do you have fun there?",
          user: "Yes, but I also study very hard.",
          audio: "level15P1TwoUAudio",
          speakerAudio: "level15P1TwoSAudio",
        },
        {
          speaker: "What do you like the most?",
          user: "I love the big library with many books.",
          audio: "level15P1ThreeUAudio",
          speakerAudio: "level15P1ThreeSAudio",
        },
        {
          speaker: "What do you study at the university?",
          user: "I study science and enjoy doing lab work.",
          audio: "level15P1FourUAudio",
          speakerAudio: "level15P1FourSAudio",
        },
        {
          speaker: "Do you live on the campus?",
          user: "Yes, I stay in the hostel with my friends.",
          audio: "level15P1FiveUAudio",
          speakerAudio: "level15P1FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P2",
    mechanics: "jumbledWord",
    data: [
      {
        correctWord: [
          {
            audio: "level15P2OneAudio",
            correctSentence:
              "The stream flowed gently near the edge of the forest.",
          },
        ],
        jumbledWords: [
          "flowed gently",
          "near the",
          "the forest.",
          "edge of",
          "The stream",
        ],
      },
      {
        correctWord: [
          {
            audio: "level15P2TwoAudio",
            correctSentence:
              "Radha smiled as she received the shining trophy on the stage.",
          },
        ],
        jumbledWords: [
          "trophy",
          "Radha smiled",
          "as she",
          "the shining",
          "received",
          "the stage.",
          "on",
        ],
      },
      {
        correctWord: [
          {
            audio: "level15P2ThreeAudio",
            correctSentence:
              "The river whispered secrets as it kissed the mountains.",
          },
        ],
        jumbledWords: [
          "whispered secrets",
          "river",
          "the mountains.",
          "as it",
          "The",
          "kissed",
        ],
      },
      {
        correctWord: [
          {
            audio: "level15P2FourAudio",
            correctSentence:
              "One sunny morning, the flowers were talking to the birds.",
          },
        ],
        jumbledWords: [
          "talking to",
          "sunny",
          "the flowers",
          "were",
          "One",
          "the birds.",
          "morning,",
        ],
      },
      {
        correctWord: [
          {
            audio: "level15P2FiveAudio",
            correctSentence:
              "The flowers in the magic garden were asleep and dreaming of the next day.",
          },
        ],
        jumbledWords: [
          "dreaming of",
          "the magic garden",
          "the next",
          "were asleep",
          "flowers in",
          "The",
          "and",
          "day.",
        ],
      },
    ],
  },
  {
    level: "P3",
    mechanics: "soundMatchR3",
    data: {
      tasks: [
        {
          question: {
            text: "Which audio clue describes something that you wear to tell time?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "BeltAudio", type: "audio" },
            { id: "audio2", value: "WatchAudio", type: "audio" },
            { id: "audio3", value: "BraceletAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes something used to write on a blackboard?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "PenAudio", type: "audio" },
            { id: "audio2", value: "ChalkAudio", type: "audio" },
            { id: "audio3", value: "EraserAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes something that keeps your feet safe outside?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "GlovesAudio", type: "audio" },
            { id: "audio2", value: "ShoesAudio", type: "audio" },
            { id: "audio3", value: "CapAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes something that helps you see when it’s dark?",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "FlashlightAudio", type: "audio" },
            { id: "audio2", value: "MirrorAudio", type: "audio" },
            { id: "audio3", value: "RulerAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes something you open at lunchtime to eat from?",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "LunchBoxAudio", type: "audio" },
            { id: "audio2", value: "EraserAudio", type: "audio" },
            { id: "audio3", value: "NotebookAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes something soft and fluffy?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "ToyAudio", type: "audio" },
            { id: "audio2", value: "PillowAudio", type: "audio" },
            { id: "audio3", value: "BasketAudio", type: "audio" },
          ],
        },
      ],
    },
  },
  {
    level: "S1",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "thingirlImg",
        imageTwo: "femaleAstronautImg",
      },
      conversation: [
        {
          speaker: "What did you feel when you saw Earth from space?",
          user: "My heart floated like a balloon filled with wonder.",
          audio: "level15S1OneUAudio",
          speakerAudio: "level15S1OneSAudio",
        },
        {
          speaker: "Were you scared during takeoff into the sky?",
          user: "My stomach flipped like a boat on wild waves.",
          audio: "level15S1TwoUAudio",
          speakerAudio: "level15S1TwoSAudio",
        },
        {
          speaker: "Did you ever feel lonely in the spaceship?",
          user: "Yes, silence sat beside me like a quiet friend.",
          audio: "level15S1ThreeUAudio",
          speakerAudio: "level15S1ThreeSAudio",
        },
        {
          speaker: "What was your favourite moment in the whole journey?",
          user: "I touched nothing, but felt everything in that silence.",
          audio: "level15S1FourUAudio",
          speakerAudio: "level15S1FourSAudio",
        },
        {
          speaker: "What do stars look like from up so high?",
          user: "They shine brighter, like diamonds on a black blanket.",
          audio: "level15S1FiveUAudio",
          speakerAudio: "level15S1FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P4",
    mechanics: "soundMatchR3",
    data: {
      tasks: [
        {
          question: {
            text: "Which audio clue describes a large bird that cannot fly and lives in cold places?",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "PenguinAudio", type: "audio" },
            { id: "audio2", value: "EagleAudio", type: "audio" },
            { id: "audio3", value: "DuckAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes an animal with a long trunk and big ears?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "HorseAudio", type: "audio" },
            { id: "audio2", value: "ElephantAudio", type: "audio" },
            { id: "audio3", value: "GiraffeAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes a pet animal that purrs and likes to chase mice?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "RabbitAudio", type: "audio" },
            { id: "audio2", value: "CatAudio", type: "audio" },
            { id: "audio3", value: "ParrotAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes a fast-running animal with black spots on its body?",
            type: "text",
          },
          answer: "audio3",
          options: [
            { id: "audio1", value: "TigerAudio", type: "audio" },
            { id: "audio2", value: "LeopardAudio", type: "audio" },
            { id: "audio3", value: "CheetahAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which audio clue describes a large farm animal that gives milk and has horns?",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "CowAudio", type: "audio" },
            { id: "audio2", value: "HorseAudio", type: "audio" },
            { id: "audio3", value: "SheepAudio", type: "audio" },
          ],
        },
      ],
    },
  },
  {
    level: "P5",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "TomImg",
        imageTwo: "JerryImg",
      },
      conversation: [
        {
          speaker: "Hey Jerry, why are you running again?",
          user: "I thought you were chasing me as usual!",
          audio: "level15P5OneUAudio",
          speakerAudio: "level15P5OneSAudio",
        },
        {
          speaker: "What are you hiding under that box?",
          user: "Just a piece of cheese I found—don’t worry!",
          audio: "level15P5TwoUAudio",
          speakerAudio: "level15P5TwoSAudio",
        },
        {
          speaker: "Why were you sneaking into the kitchen last night?",
          user: "I was just checking if the cake was still fresh!",
          audio: "level15P5ThreeUAudio",
          speakerAudio: "level15P5ThreeSAudio",
        },
        {
          speaker: "Jerry, did you eat my sandwich again?",
          user: "Oops… I thought it was a gift!",
          audio: "level15P5FourUAudio",
          speakerAudio: "level15P5FourSAudio",
        },
        {
          speaker: "Why are you always so fast?",
          user: "Because I have to stay one step ahead of you!",
          audio: "level15P5FiveUAudio",
          speakerAudio: "level15P5FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P6",
    mechanics: "askMore",
    data: {
      images: {
        imageOne: "boyChild2Img",
        imageTwo: "thingirlImg",
      },
      conversation: [
        {
          speaker: "How do the big whales swim?",
          user: "Whales move their tails up and down to swim smoothly.",
          audio: "level15P6OneUAudio",
          speakerAudio: "level15P6OneSAudio",
        },
        {
          speaker: "What do whales eat in the sea?",
          user: "Some whales eat tiny fish and krill by filtering water through their mouths.",
          audio: "level15P6TwoUAudio",
          speakerAudio: "level15P6TwoSAudio",
        },
        {
          speaker: "Have you ever seen a dolphin?",
          user: "Yes! I saw one jumping out of the water in a video.",
          audio: "level15P6ThreeUAudio",
          speakerAudio: "level15P6ThreeSAudio",
        },
        {
          speaker: "Why do fish live in groups?",
          user: "They stay in groups to stay safe from bigger animals.",
          audio: "level15P6FourUAudio",
          speakerAudio: "level15P6FourSAudio",
        },
        {
          speaker: "What do you like most about the sea?",
          user: "I love the sound of waves and the colourful sea animals.",
          audio: "level15P6FiveUAudio",
          speakerAudio: "level15P6FiveSAudio",
        },
      ],
    },
  },
  {
    level: "P7",
    mechanics: "soundMatchR3",
    data: {
      tasks: [
        {
          question: {
            text: "Dogs _______ when they see thieves.",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "BarksAudio", type: "audio" },
            { id: "audio2", value: "MeowsAudio", type: "audio" },
            { id: "audio3", value: "HissesAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Cows ____________ when they need food.",
            type: "text",
          },
          answer: "audio3",
          options: [
            { id: "audio1", value: "BarksAudio", type: "audio" },
            { id: "audio2", value: "MeowsAudio", type: "audio" },
            { id: "audio3", value: "mooAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "What do horses do when they are excited?",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "NeighAudio", type: "audio" },
            { id: "audio2", value: "mooAudio", type: "audio" },
            { id: "audio3", value: "BarksAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "How does a lion show their power? ",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "LionUAudio", type: "audio" },
            { id: "audio2", value: "BarksAudio", type: "audio" },
            { id: "audio3", value: "MeowsAudio", type: "audio" },
          ],
        },
        {
          question: {
            text: "Monkeys ________ when they play in trees.",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "MonkeyAudio", type: "audio" },
            { id: "audio2", value: "BarksAudio", type: "audio" },
            { id: "audio3", value: "LionAudio", type: "audio" },
          ],
        },
      ],
    },
  },
  {
    level: "P8",
    mechanics: "fillInTheBlankNew",
    data: {
      instruction: {
        content: [
          {
            type: "image",
            value: "",
            text: "Find out the parallel phrase",
          },
        ],
      },
      tasks: [
        {
          question: "She chased her dreams, even when others told her not to.",
          options: [
            {
              id: "option1",
              value:
                "She wandered under the night sky, captivated by the beauty of the stars.",
            },
            {
              id: "option2",
              value:
                "She followed her dreams fearlessly, even when others told her to be realistic.",
            },
            {
              id: "option3",
              value:
                "She stayed up all night stargazing, lost in quiet wonder.",
            },
          ],
          answer: "option2",
        },
        {
          question:
            "Time dragged itself across the day as she struggled to complete her homework",
          options: [
            {
              id: "option1",
              value:
                "The rain pressed against the windows as she raced to finish her homework.",
            },
            {
              id: "option2",
              value:
                "The sun dipped behind the hills as she scribbled the last lines of her essay.",
            },
            {
              id: "option3",
              value: "The day crawled by as she struggled with her homework.",
            },
          ],
          answer: "option3",
        },
        {
          question: "Raju froze like a statue as the snake was too close.",
          options: [
            {
              id: "option1",
              value: "The mountains were frozen and stood still in the winter.",
            },
            {
              id: "option2",
              value: "Raju held his breath; fear tied him in chains.",
            },
            {
              id: "option3",
              value: "Raju was afraid when he saw the snake move.",
            },
          ],
          answer: "option2",
        },
        {
          question:
            "Radha stood spellbound as her name was announced as the champion.",
          options: [
            {
              id: "option1",
              value:
                "Radha stood speechless as the curtains rose on the final performance.",
            },
            {
              id: "option2",
              value:
                "Radha felt scared as the thunder cracked loudly overhead.",
            },
            {
              id: "option3",
              value:
                "Radha froze in awe as she heard her name declared the winner.",
            },
          ],
          answer: "option3",
        },
        {
          question: "The river danced merrily down the little valley.",
          options: [
            {
              id: "option1",
              value:
                "The children laughed loudly as they skipped across the schoolyard.",
            },
            {
              id: "option2",
              value:
                "The wind whispered softly through the tall grass on the hillside",
            },
            {
              id: "option3",
              value:
                "The cheerful stream tumbled playfully through the narrow valley.",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "S2",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "anouncement",
        imageOne: "childImage",
        imageTwo: "boyFromSuperMarket",
        imageThree: "supermarketAnouncementImg",
        content: [
          {
            role: "System",
            message:
              "You went to a supermarket and bought these five items: Bananas, Milk, Sugar, Bread, and Cucumber. You wanted to prepare a sandwich using bread and cucumber. You plan to make a sweet dish using sugar, milk, and bananas. Cucumber can also be used to prepare a healthy salad.",
            audio: "superMarketAnouncementAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What are the five items you bought?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Bananas, Bread, Milk, Sugar, and Eggs",
            },
            {
              type: "text",
              id: "option2",
              value: "Bananas, Milk, Sugar,  Bread and Cucumber",
            },
            {
              type: "text",
              id: "option3",
              value: "Bananas, Bread, Cheese, Sugar, and Cucumber",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What is the second item on your list?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Milk",
            },
            {
              type: "text",
              id: "option2",
              value: "Bread",
            },
            {
              type: "text",
              id: "option3",
              value: "Sugar",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "Which item is used to sweeten food or drinks?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Bread",
            },
            {
              type: "text",
              id: "option2",
              value: "Sugar",
            },
            {
              type: "text",
              id: "option3",
              value: "Milk",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Which two items are used to make a sandwich?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Bread and Banana",
            },
            {
              type: "text",
              id: "option2",
              value: "Bread and Cucumber",
            },
            {
              type: "text",
              id: "option3",
              value: "Bread and Milk",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Which item can be used to prepare a healthy salad?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Banana",
            },
            {
              type: "text",
              id: "option2",
              value: "Bread",
            },
            {
              type: "text",
              id: "option3",
              value: "Cucumber",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
];

export const level10 = [
  {
    level: "P1",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "trainImgOne",
        imageTwo: "trainImgTwo",
        imageThree: "railAnnouncementImg",
        content: [
          {
            role: "System",
            message:
              "Attention, passengers! Train number 1267, Karnataka Express from Bengaluru to New Delhi, via Guntakal, Nagpur, and Bhopal, is arriving shortly on Platform Number 5. Passengers are requested to stand behind the yellow line and allow the passengers to alight first. Please check your tickets and belongings before boarding. Thank you.",
            audio: "bengaluruTrainAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Where is the Karnataka Express going?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Lucknow",
            },
            {
              type: "text",
              id: "option2",
              value: "Mumbai",
            },
            {
              type: "text",
              id: "option3",
              value: "New Delhi",
            },
            {
              type: "text",
              id: "option4",
              value: "Hyderabad",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What is the train number mentioned in the announcement?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "1262",
            },
            {
              type: "text",
              id: "option2",
              value: "1267",
            },
            {
              type: "text",
              id: "option3",
              value: "1276",
            },
            {
              type: "text",
              id: "option4",
              value: "1627",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "On which platform will the train arrive?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Platform No. 1",
            },
            {
              type: "text",
              id: "option2",
              value: "Platform No. 2",
            },
            {
              type: "text",
              id: "option3",
              value: "Platform No. 5",
            },
            {
              type: "text",
              id: "option4",
              value: "Platform No. 4",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "What safety instruction is given to the passengers?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Stand near the edge of the platform",
            },
            {
              type: "text",
              id: "option2",
              value: "Stay behind the yellow line",
            },
            {
              type: "text",
              id: "option3",
              value: "Rush towards the train",
            },
            {
              type: "text",
              id: "option4",
              value: "Leave their belongings behind",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Why should passengers not rush towards the train?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "To let the train leave quickly",
            },
            {
              type: "text",
              id: "option2",
              value: "To allow passengers to get off first",
            },
            {
              type: "text",
              id: "option3",
              value: "To avoid missing the train",
            },
            {
              type: "text",
              id: "option4",
              value: "To get a window seat",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
  {
    level: "P2",
    mechanics: "fillInTheBlankNew",
    data: {
      instruction: {
        content: [
          {
            type: "image",
            value: "childrenDayImg",
          },
        ],
      },
      tasks: [
        {
          question: "Children’s Day is celebrated on ______ (date).",
          options: [
            { id: "option1", value: "November 14" },
            { id: "option2", value: "January 26" },
            { id: "option3", value: "August 15" },
          ],
          answer: "option1",
        },
        {
          question: "The celebration takes place at ______ (school name).",
          options: [
            { id: "option1", value: "ABC Public School" },
            { id: "option2", value: "GHPS, Rampura" },
            { id: "option3", value: "DEF International School" },
          ],
          answer: "option2",
        },
        {
          question:
            "Prize and sweets distribution include sports competitions and ______.",
          options: [
            { id: "option1", value: "cultural activities" },
            { id: "option2", value: "exams" },
            { id: "option3", value: "homework" },
          ],
          answer: "option1",
        },
        {
          question:
            "The picture shows children playing happily in a ______ (place).",
          options: [
            { id: "option1", value: "classroom" },
            { id: "option2", value: "park" },
            { id: "option3", value: "library" },
          ],
          answer: "option2",
        },
        {
          question:
            "The message at the bottom of the image says: ______ are the heart of our Nation!’",
          options: [
            { id: "option1", value: "Teachers" },
            { id: "option2", value: "Parents" },
            { id: "option3", value: "Children" },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "P3",
    mechanics: "soundMatchR3",
    data: {
      tasks: [
        {
          question: {
            text: "Which announcement is about an upcoming event?   ",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P3OneAudio1", type: "audio" },
            { id: "audio2", value: "level10P3OneAudio2", type: "audio" },
            { id: "audio3", value: "level10P3OneAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which announcement is about a competition?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P3TwoAudio1", type: "audio" },
            { id: "audio2", value: "level10P3TwoAudio2", type: "audio" },
            { id: "audio3", value: "level10P3TwoAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which announcement is about classroom behaviour?",
            type: "text",
          },
          answer: "audio1",
          options: [
            { id: "audio1", value: "level10P3ThreeAudio1", type: "audio" },
            { id: "audio2", value: "level10P3ThreeAudio2", type: "audio" },
            { id: "audio3", value: "level10P3ThreeAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which announcement is about discipline in play ground?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P3FourAudio1", type: "audio" },
            { id: "audio2", value: "level10P3FourAudio2", type: "audio" },
            { id: "audio3", value: "level10P3FourAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which announcement is about homework submission?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P3FiveAudio1", type: "audio" },
            { id: "audio2", value: "level10P3FiveAudio2", type: "audio" },
            { id: "audio3", value: "level10P3FiveAudio3", type: "audio" },
          ],
        },
      ],
    },
  },
  {
    level: "P4",
    mechanics: "AnnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "trainImgOne",
        imageTwo: "trainImgTwo",
        imageThree: "railAnnouncementImg",
        content: [
          {
            role: "System",
            message:
              "Attention, passengers!Train number 22645, Indore Express from Hyderabad to Indore, via Akola and Bhopal, is now ready for departure from Platform Number 3. Passengers are requested to board the train with valid tickets and ensure they have all their belongings with them. Thank you.",
            audio: "toyTrainAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What is the name of the train?",
          },
          options: [
            { type: "text", id: "option1", value: "Hyderabad Express" },
            { type: "text", id: "option2", value: "Bhopal Express" },
            { type: "text", id: "option3", value: "Indore Mail" },
            { type: "text", id: "option4", value: "Indore Express" },
          ],
          answer: "option4",
        },
        {
          question: {
            type: "text",
            value: "From which city is the train starting?",
          },
          options: [
            { type: "text", id: "option1", value: "Indore" },
            {
              type: "text",
              id: "option2",
              value: "Akola",
            },
            {
              type: "text",
              id: "option3",
              value: "Hyderabad",
            },
            {
              type: "text",
              id: "option4",
              value: "Bhopal",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value:
              "Which cities does the Indore Express pass through on its way?",
          },
          options: [
            { type: "text", id: "option1", value: "Nagpur and Bhopal" },
            { type: "text", id: "option2", value: "Akola and Bhopal" },
            { type: "text", id: "option3", value: "Secunderabad and Pune" },
            { type: "text", id: "option4", value: "Guntakal and Akola" },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value:
              "What is the main instruction for passengers in the announcement?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Buy tickets from the counter",
            },
            {
              type: "text",
              id: "option2",
              value: "Show ID cards to the guard",
            },
            { type: "text", id: "option3", value: "Take food before boarding" },
            {
              type: "text",
              id: "option4",
              value: "Board with valid tickets and belongings",
            },
          ],
          answer: "option4",
        },
        {
          question: {
            type: "text",
            value: "What does the announcement say about the train's status?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "It is late by one hour",
            },
            {
              type: "text",
              id: "option2",
              value: "It is arriving at Platform 3",
            },
            { type: "text", id: "option3", value: " It is ready to depart" },
            { type: "text", id: "option4", value: " It is cancelled today" },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "S1",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "villageDramaImg",
        imageTwo: "childrenImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "Attention, everyone! A special drama titled Raja and Praja will be performed this Saturday. The show begins at 7 PM in the school ground. The youth club presents the drama. All are invited to enjoy the drama. Don’t miss it!",
            audio: "villageAnnouncementAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What is the title of the drama?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Raja and Praja",
            },
            {
              type: "text",
              id: "option2",
              value: "King and People",
            },
            {
              type: "text",
              id: "option3",
              value: "Raja and Darbar",
            },
            {
              type: "text",
              id: "option4",
              value: "Maha Raja",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "On which day will the drama be performed?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Friday",
            },
            {
              type: "text",
              id: "option2",
              value: "Saturday",
            },
            {
              type: "text",
              id: "option3",
              value: "Sunday",
            },
            {
              type: "text",
              id: "option4",
              value: "Monday, 10th June",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What time does the show begin?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "6 PM",
            },
            {
              type: "text",
              id: "option2",
              value: "7 PM",
            },
            {
              type: "text",
              id: "option3",
              value: "8 PM",
            },
            {
              type: "text",
              id: "option4",
              value: "Classroom",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Where will the drama take place?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "In the school hall",
            },
            {
              type: "text",
              id: "option2",
              value: "On the school ground",
            },
            {
              type: "text",
              id: "option3",
              value: "In the market",
            },
            {
              type: "text",
              id: "option4",
              value: "Only teachers",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Who is presenting the drama?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Teachers",
            },
            {
              type: "text",
              id: "option2",
              value: "Youth club",
            },
            {
              type: "text",
              id: "option3",
              value: "Students",
            },
            {
              type: "text",
              id: "option4",
              value: "Everyone",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
  {
    level: "P5",
    mechanics: "AnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "TvBreakingNewsImg",
        imageTwo: "HeavyRainImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "Attention, everyone!The Meteorological Department has forecast heavy to very heavy rainfall across parts of South India over the next two days. Affected regions include coastal and interior areas of Karnataka, Tamil Nadu, Kerala, and Andhra Pradesh.Safety Precautions: People are advised to stay indoors unless necessary.Avoid waterlogged and low-lying areas. Follow all safety guidelines issued by local authorities. Store enough food and necessary medicines in case of emergencies. Schools will remain closed in affected regions.Stay tuned to official weather updates and stay safe.",
            audio: "RainAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "What is the main reason for this announcement?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "To announce a festival",
            },
            {
              type: "text",
              id: "option2",
              value: "To warn about heavy rainfall",
            },
            {
              type: "text",
              id: "option3",
              value: "To inform about school exams",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What should people avoid during the rain?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Shopping malls",
            },
            {
              type: "text",
              id: "option2",
              value: "Highways",
            },
            {
              type: "text",
              id: "option3",
              value: "Waterlogged areas",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "Which part of India is expected to receive heavy rain?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "North India",
            },
            {
              type: "text",
              id: "option2",
              value: "South India",
            },
            {
              type: "text",
              id: "option3",
              value: "Central India",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value:
              "What precautionary measure is suggested in case the situation worsens?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Buying new clothes and umbrellas",
            },
            {
              type: "text",
              id: "option2",
              value: "Moving to another city",
            },
            {
              type: "text",
              id: "option3",
              value: "Storing essential food and medicines",
            },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value:
              "Which of these is a safety instruction from the announcement?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Go out and check the roads",
            },
            {
              type: "text",
              id: "option2",
              value: "Travel as much as possible",
            },
            {
              type: "text",
              id: "option3",
              value: "Stay indoors unless necessary",
            },
          ],
          answer: "option3",
        },
      ],
    },
  },
  {
    level: "P6",
    mechanics: "fillInTheBlankNew",
    data: {
      instruction: {
        content: [
          {
            type: "image",
            value: "goodtouchImg",
          },
        ],
      },
      tasks: [
        {
          question: "A good touch makes you feel ______.",
          options: [
            { id: "option1", value: "safe" },
            { id: "option2", value: "scared" },
            { id: "option3", value: "uncomfortable" },
          ],
          answer: "option1",
        },
        {
          question:
            "Examples of good touch include a ______ from your parents.",
          options: [
            { id: "option1", value: "hug" },
            { id: "option2", value: "slap" },
            { id: "option3", value: "push" },
          ],
          answer: "option1",
        },
        {
          question:
            "If someone touches you in a way that makes you unsafe, you should ______.",
          options: [
            { id: "option1", value: "say no" },
            { id: "option2", value: "stay quiet" },
            { id: "option3", value: "ignore" },
          ],
          answer: "option1",
        },
        {
          question: "The trusted adults you can talk to include your ______.",
          options: [
            { id: "option1", value: "parents" },
            { id: "option2", value: "strangers" },
            { id: "option3", value: "neighbors" },
          ],
          answer: "option1",
        },
        {
          question: "It is important to remember that it is never your ______.",
          options: [
            { id: "option1", value: "fault" },
            { id: "option2", value: "umbrella" },
            { id: "option3", value: "vacation" },
          ],
          answer: "option1",
        },
      ],
    },
  },
  {
    level: "P7",
    mechanics: "soundMatchR3",
    data: {
      tasks: [
        {
          question: {
            text: "Which announcement is about a weekend sale?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P7OneAudio1", type: "audio" },
            { id: "audio2", value: "level10P7OneAudio2", type: "audio" },
            { id: "audio3", value: "level10P7OneAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which announcement is about maintaining silence in the hospital?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P7TwoAudio1", type: "audio" },
            { id: "audio2", value: "level10P7TwoAudio2", type: "audio" },
            { id: "audio3", value: "level10P7TwoAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which announcement is about switching off mobile phones during flight takeoff? ",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P7ThreeAudio1", type: "audio" },
            { id: "audio2", value: "level10P7ThreeAudio2", type: "audio" },
            { id: "audio3", value: "level10P7ThreeAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which announcement is about Respecting Teachers?",
            type: "text",
          },
          answer: "audio2",
          options: [
            { id: "audio1", value: "level10P7FourAudio1", type: "audio" },
            { id: "audio2", value: "level10P7FourAudio2", type: "audio" },
            { id: "audio3", value: "level10P7FourAudio3", type: "audio" },
          ],
        },
        {
          question: {
            text: "Which of the following is Not part of the classroom announcement?",
            type: "text",
          },
          answer: "audio3",
          options: [
            { id: "audio1", value: "level10P7FiveAudio1", type: "audio" },
            { id: "audio2", value: "level10P7FiveAudio2", type: "audio" },
            { id: "audio3", value: "level10P7FiveAudio3", type: "audio" },
          ],
        },
      ],
    },
  },
  {
    level: "P8",
    mechanics: "AnnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "hockeyImg",
        imageTwo: "TwogirlsImg",
        imageThree: "AnnouncementLadyImg",
        content: [
          {
            role: "System",
            message:
              "Announcement: Women’s Hockey Tournament. The Indian Women’s Hockey Team will take on Australia in a high-stakes match on Saturday, 22nd June 2025. The match will be held at the Major Dhyan Chand National Stadium in Delhi, and Salima Tete will lead the Indian team.Tickets are now available at the stadium ticket counters and online. Don’t miss your chance—book early!Important Guidelines for the Audience:Gates open at 3:00 PM. The match begins at 4:00 PM sharp.Bring your ticket and a valid photo ID for entry.Please follow security rules and help maintain discipline.Come and cheer for our women's champions—support Indian women’s hockey!",
            audio: "hockeyAnnouncementAudio",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Who will the Indian Women’s Hockey Team play against?",
          },
          options: [
            { type: "text", id: "option1", value: "England" },
            { type: "text", id: "option2", value: "Australia" },
            { type: "text", id: "option3", value: "New Zealand" },
            { type: "text", id: "option4", value: "Argentina" },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "When is the match scheduled?",
          },
          options: [
            { type: "text", id: "option1", value: "Sunday, 23rd June 2025" },
            { type: "text", id: "option2", value: "Friday, 21st June 2025" },
            { type: "text", id: "option3", value: "Saturday, 22nd June 2025" },
            { type: "text", id: "option4", value: "Monday, 24th June 2025" },
          ],
          answer: "option3",
        },
        {
          question: {
            type: "text",
            value: "Where will the hockey match take place?",
          },
          options: [
            { type: "text", id: "option1", value: "Eden Gardens Stadium" },
            {
              type: "text",
              id: "option2",
              value: "Major Dhyan Chand National Stadium",
            },
            { type: "text", id: "option3", value: "Jawaharlal Nehru Stadium" },
            { type: "text", id: "option4", value: "Mumbai Stadium" },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What should the audience carry for entry to the stadium?",
          },
          options: [
            { type: "text", id: "option1", value: "Only a water bottle" },
            {
              type: "text",
              id: "option2",
              value: "A ticket and a valid photo ID",
            },
            { type: "text", id: "option3", value: "A camera and food" },
            { type: "text", id: "option4", value: "A mobile phone and a bag" },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value:
              "Who is the captain of the Indian Women’s Hockey Team in this match?",
          },
          options: [
            { type: "text", id: "option1", value: "Neha Goyal" },
            { type: "text", id: "option2", value: "Salima Tete" },
            { type: "text", id: "option3", value: "Vandana Katariya" },
            { type: "text", id: "option4", value: "Rani Rampal" },
          ],
          answer: "option2",
        },
      ],
    },
  },
  {
    level: "S2",
    mechanics: "AnnouncementFlow",
    data: {
      instructions: {
        type: "announcement",
        imageOne: "womanphoneImg",
        imageTwo: "childphoneImg",
        imageThree: "telephoneImg",
        content: [
          {
            role: "System",
            name: "Announcement",
            message:
              "Hello? Is this Meena? Yes, Aunty. Who’s speaking? It’s Ratna Aunty. How are you? I’m good. Just got back from school. Is your mother home? No, she’s at a meeting. Please come to my son’s birthday on Sunday at 4 PM, at our house. Sounds fun! I’ll tell Mum. Great! Let me know later. Bye! Bye, Aunty!",
            audio: "level10S2Announcement",
          },
        ],
      },
      tasks: [
        {
          question: {
            type: "text",
            value: "Who is calling Meena?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Her teacher",
            },
            {
              type: "text",
              id: "option2",
              value: "Ratna Aunty",
            },
            {
              type: "text",
              id: "option3",
              value: "Her friend",
            },
            {
              type: "text",
              id: "option4",
              value: "Mr. Suresh",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "Where is Meena’s mother?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "At home",
            },
            {
              type: "text",
              id: "option2",
              value: "At a meeting",
            },
            {
              type: "text",
              id: "option3",
              value: "In the market",
            },
            {
              type: "text",
              id: "option4",
              value: "She is at the office",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "What event is Ratna Aunty inviting Meena to?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "A wedding",
            },
            {
              type: "text",
              id: "option2",
              value: "A birthday party",
            },
            {
              type: "text",
              id: "option3",
              value: "A school event",
            },
            {
              type: "text",
              id: "option4",
              value: "A graduation ceremony",
            },
          ],
          answer: "option2",
        },
        {
          question: {
            type: "text",
            value: "When is the party?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Sunday at 4 PM",
            },
            {
              type: "text",
              id: "option2",
              value: "Saturday morning",
            },
            {
              type: "text",
              id: "option3",
              value: "Friday evening",
            },
            {
              type: "text",
              id: "option4",
              value: "Monday morning",
            },
          ],
          answer: "option1",
        },
        {
          question: {
            type: "text",
            value: "What will happen at the party?",
          },
          options: [
            {
              type: "text",
              id: "option1",
              value: "Only dinner",
            },
            {
              type: "text",
              id: "option2",
              value: "Games, cake, and dinner",
            },
            {
              type: "text",
              id: "option3",
              value: "Just cake",
            },
            {
              type: "text",
              id: "option4",
              value: "A wedding",
            },
          ],
          answer: "option2",
        },
      ],
    },
  },
];

export const levelMapping = {
  6760800019: 12,
  1621936833: 13,
  9526496994: 14,
  9620863046: 10,
  9034863942: 10,
  7514980670: 11,
  2343266887: 11,
  6769723880: 12,
  4908796006: 13,
  7085183264: 14,
  9139845767: 15,
  3574322755: 10,
  8192835415: 10,
  2051091130: 12,
  8920707322: 15,
  1012988598: 10,
  9025374424: 11,
  4708438660: 11,
  5959090366: 10,
  4498321123: 10,
  8232305398: 10,
  9926847910: 10,
  4221431178: 10,
  4737383411: 10,
  1720960133: 11,
  4643584690: 12,
  2859035477: 13,
};
